import React from 'react';

export const PingPongTableIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {/* Поверхность стола (зеленая) */}
      <rect x="18" y="7" width="28" height="50" rx="1" fill="#388E3C" stroke="#1B5E20" strokeWidth="1"/>

      {/* Белая окантовка */}
      <rect x="20" y="9" width="24" height="46" stroke="white" strokeWidth="1" strokeOpacity="0.8"/>

      {/* Центральная линия (продольная) */}
      <line x1="32" y1="9" x2="32" y2="55" stroke="white" strokeWidth="1" strokeOpacity="0.8"/>

      {/* Сетка (поперечная) - выступает за края */}
      <line x1="16" y1="32" x2="48" y2="32" stroke="#E0E0E0" strokeWidth="2"/>
      {/* Фактура сетки */}
      <line x1="16" y1="32" x2="48" y2="32" stroke="#9E9E9E" strokeWidth="1" strokeDasharray="2 2"/>

      {/* Крепления сетки */}
      <circle cx="16" cy="32" r="1.5" fill="#212121"/>
      <circle cx="48" cy="32" r="1.5" fill="#212121"/>

      {/* Тени/Блики для объема (опционально, легкий градиент имитируем линией) */}
      <line x1="21" y1="9" x2="21" y2="55" stroke="white" strokeWidth="2" strokeOpacity="0.1"/>
    </svg>
  );
};
